<ion-card>
    <ion-card-header color="clickker-purple">
        <ion-card-title>{{title}}</ion-card-title>
    </ion-card-header>
    <ion-card-content class="logListContent">
        @if (this.data || isLoading) {
            <canvas baseChart
                    [data]="barChartData"
                    [options]="barChartOptions"
                    [type]="'bar'"
                    (chartClick)="chartClicked($event)">
            </canvas>

            <div class="zoomOutButtonContainer">
                @if (!isLoading) {
                    <ion-button [disabled]="!canZoomOut" (click)="onZoomOut()" size="small" ><ion-icon name="remove-circle-outline"></ion-icon>
                        {{ "components.dashboard.chart.zoomOutButton" | translate }}</ion-button>
                } @else {
                    <div class="loadingSpinner">
                        <ion-spinner></ion-spinner> {{ "components.dashboard.chart.loadingMessage" | translate }}
                    </div>
                }
            </div>
        } @else {
            <ion-row class="ion-align-items-center ion-justify-content-center loadingContainer">
                <span>{{"components.dashboard.chart.noDataMessage" | translate }}</span>
            </ion-row>
        }


    </ion-card-content>
</ion-card>
